import { createFileRoute } from '@tanstack/react-router';

import { CertificatePage } from '@pages/certificate';
import { getPreferredLocale, syncLanguageFromUrl } from '@shared/config/i18n';

export const Route = createFileRoute('/certificates/$certificateLogId')({
  beforeLoad: () => {
    syncLanguageFromUrl(getPreferredLocale());
  },
  component: CertificateRoute,
});

function CertificateRoute() {
  const { certificateLogId } = Route.useParams();
  return <CertificatePage key={certificateLogId} certificateLogId={certificateLogId} />;
}
